import { screen } from '@/router/screenRoutes';

export default [
  {
    ...screen('livelo-statement'),
    component: () => import('@/views/LiveloStatement.vue'),
    props: true,
  },
  {
    ...screen('livelo-landing-page'),
    component: () => import('@/views/LiveloLandingPage.vue'),
    props: true,
  },
];
